import { clearLocalStorage } from "@base/helpers/common";
import { setAuth, setStringeeToken, setUserInfo } from "@base/store/reducers/appCommonSlice";
import { store } from "@base/store/store";

/**
 * Single exit point for every logout path: wipes the session from storage + redux, then leaves
 * for `redirectTo`. Deliberately does NOT call the logout API - callers that still hold a valid
 * token are responsible for doing that first, while the token can still authorize the request.
 */
let isClearing = false;

export const clearSession = (redirectTo: string) => {
  // Several requests can fail with 401 at once and each would tear the session down again.
  // First caller wins; no reset needed because the page is on its way out.
  if (isClearing) {
    return;
  }

  isClearing = true;

  clearLocalStorage();

  store.dispatch(setAuth(undefined));
  store.dispatch(setUserInfo(undefined));
  store.dispatch(setStringeeToken(undefined));

  // Guard against replacing the page with itself (a 401 raised while already sitting on /login).
  if (`${window.location.pathname}${window.location.search}` !== redirectTo) {
    window.location.replace(redirectTo);
  }
};
